module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/btn_check_sp_on-fa204651fb68eb74fc189d01c1a9820c.png";